// extracted by mini-css-extract-plugin
module.exports = {"inputFileWrapper":"InputFile_inputFileWrapper__3cmB7","label":"InputFile_label__3CA5_","inputFile":"InputFile_inputFile__128F-"};